// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/shop-mini-basket-schema',
  type: 'object',
  required: ['id', 'itemsTotalQuantity'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    publicBasketId: {
      type: 'string',
      format: 'uuid',
    },
    itemsTotalQuantity: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
